export default "__VITE_ASSET__BR3jlmY2__"